import { NewShowJobs } from "../new-show-jobs/newShowJobs";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchJobs } from "../../../store/thunks/jobs";
import { setFavourite } from "../../../store/actions/favourite-actions";
import {
  addFilter,
  removeFilter,
  clearFilters,
  removeFromFilters,
  addToFilters,
} from "../../../store/actions/filter-actions";
import { withRouter } from "react-router-dom";
import { paths } from "../../../constants/paths";

const mapStateToProps = (state) => {
  return {
    canonical: `https://justremote.co${paths.developer_jobs}`,
    category: "developer",
    meta: state.jobsState.meta,
    jobs: state.jobsState.entity.all.filter(
      (job) => job.category === "developer"
    ),
    filters: state.filterState.developer.filters,
    filtersApplied: state.filterState.developer.filtersApplied,
    favourited: state.favouriteState.favourites,
    job: state.singleJobState.developer,
    pageTitle: `Remote Developer Jobs - JustRemote`,
    pageDesc:
      "Remote Developer Jobs from around the globe. Frontend and backend developer positions including ReactJS, Javascript, Java, Python and Angular jobs.",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchJobs: bindActionCreators(fetchJobs, dispatch),
    handleFavouriteClick(job) {
      dispatch(setFavourite(job));
    },
    addFilter(filter) {
      dispatch(addFilter(filter));
    },
    removeFilter(filter) {
      dispatch(removeFilter(filter));
    },
    clearFilters(category) {
      dispatch(clearFilters(category));
    },
    removeFromFilters(filter) {
      dispatch(removeFromFilters(filter));
    },
    addToFilters(filter) {
      dispatch(addToFilters(filter));
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NewShowJobs)
);
